import React, { useState } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import "./Portfolio.css"
import { one, two, three, four, five } from "../images"
const GraphicCard = () => {
  const [currentImage, setCurrentImage] = useState(0);

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const carouselItems = [
    {
      id: 1,
      imageUrl: one,
      videoLink: 'https://drive.google.com/file/d/1yRrwQJlSLwdLpVQa4c_JpVCOxxf-7vDR/view?usp=drive_link', // Add video link for image 1
    },
    {
      id: 2,
      imageUrl: two,
      videoLink: 'https://drive.google.com/file/d/1zopYLZtO2Y-a6QrzCZTitBF64Ea-yj5U/view?usp=drive_link', // Add video link for image 2
    },
    {
      id: 3,
      imageUrl: three,
      videoLink: 'https://drive.google.com/file/d/1S1TGZuFjcS9NfCKH0Duztgw7-0b6qdqb/view?usp=drive_link', // Add video link for image 3
    },
    {
      id: 4,
      imageUrl: four,
      videoLink: 'https://drive.google.com/file/d/1YGYsBEMpAE8lbQTGzlwJmRsCzyhDnvyk/view?usp=drive_link', // Add video link for image 4
    },
    {
      id: 5,
      imageUrl: five,
      videoLink: 'https://drive.google.com/file/d/1ho2fJYMcUafI0cOKYtrSN3630L4ljEHZ/view?usp=drive_link', // Add video link for image 5
    },
  ];

  const handleNextImage = () => {
    setCurrentImage((prevImage) => (prevImage + 1) % carouselItems.length);
  };

  const handlePrevImage = () => {
    setCurrentImage((prevImage) =>
      prevImage === 0 ? carouselItems.length - 1 : prevImage - 1
    );
  };

  const handleWatchVideo = () => {
    // Open the video link in a new tab or window
    window.open(carouselItems[currentImage].videoLink, '_blank');
  };
  

  return (
    <div className="graphic-card-container">
      <Carousel
        swipeable={false}
        draggable={false}
        showDots={true}
        responsive={responsive}
        ssr={true} // Server-side rendering support
        infinite={true}
        autoPlay={true} // Enable autoplay
        autoPlaySpeed={3000} // Set autoplay interval to 3 seconds
        keyBoardControl={true}
        customTransition="transform 300ms ease-in-out"
      >
        {carouselItems.map((item) => (
          <div key={item.id} className="carousel-image">
            <img
              src={item.imageUrl}
              alt={`Image ${item.id}`}
              width="800"
              height="800"
            />
            <button className="watch-button" onClick={handleWatchVideo}>
              Watch
            </button>
          </div>
        ))}
      </Carousel>
   
    </div>
  );
};

export default GraphicCard;
